import { secondsToTimelineTime, DEFAULT_FPS } from '~/Util'
import ProjectAsset from '~/models/ProjectData/ProjectAsset'

/**
 * @memberOf ProjectData
 * @extends ProjectData.ProjectVideoAsset
 *
 */

class ProjectVideoAsset extends ProjectAsset {

  constructor(jsonData) {
    const {
      volume,
      muted,
      mediaFileDuration,
      mediaPlayerDuration,
      visible,
      fadeInDuration = secondsToTimelineTime(3),
      fadeOutDuration = secondsToTimelineTime(3),
      fadeInIsActive = false,
      fadeOutIsActive = false,
      colorPrimaries,
      dfFlag,
      startTimeCodeFrames,
      fpsDenum,
      fpsNum,
    } = jsonData
    super(jsonData)

    const { settings } = jsonData

    this._settings = { ...settings }

    this._volume = volume
    this._muted = muted
    this._mediaFileDuration = mediaFileDuration
    this._mediaPlayerDuration = mediaPlayerDuration || mediaFileDuration
    this._visible = visible
    this._fadeInDuration = fadeInDuration
    this._fadeOutDuration = fadeOutDuration
    this._fadeInIsActive = fadeInIsActive
    this._fadeOutIsActive = fadeOutIsActive
    this._colorPrimaries = colorPrimaries
    this._dfFlag = dfFlag
    this._startTimeCodeFrames = startTimeCodeFrames
    this._fpsDenum = fpsDenum
    this._fpsNum = fpsNum
  }

  get colorPrimaries() {
    return this._colorPrimaries
  }

  /**
   * @param {string} colorPrimaries
   */
  set colorPrimaries(value) {
    this._colorPrimaries = value
  }

  /**
   * @returns {number}
  */
  get startTimeCodeFrames() {
    return this._startTimeCodeFrames
  }

  /**
   * @param {number} value
  */
  set startTimeCodeFrames(value) {
    this._startTimeCodeFrames = value
  }

  /**
   * @returns {number}
  */
  get dfFlag() {
    return this._dfFlag
  }

  /**
   * @param {number} value
  */
  set dfFlag(value) {
    this._dfFlag = value
  }

  get volume() {
    return this._volume
  }

  /**
   * @param {number} volume
   */
  set volume(volume) {
    this._volume = volume
  }

  get muted() {
    return this._muted
  }

  /**
   * @param {boolean} muted
   */
  set muted(muted) {
    this._muted = muted
  }

  get visible() {
    return this._visible
  }

  /**
   * @param {boolean} visible
   */
  set visible(visible) {
    this._visible = visible
  }

  get mediaFileDuration() {
    return this._mediaFileDuration
  }

  /**
   * @param {number} mediaFileDuration
   */
  set mediaFileDuration(mediaFileDuration) {
    this._mediaFileDuration = mediaFileDuration
  }

  get mediaPlayerDuration() {
    return this._mediaPlayerDuration
  }

  /**
   * @param {number} duration
   */
  set mediaPlayerDuration(duration) {
    this._mediaPlayerDuration = duration
  }

  /**
   * @returns {Object}
   */
  get settings() {
    return this._settings
  }

  // ---
  /**
   * @returns {number} 100-nanoseconds units
   */
  get fadeInDuration() {
    return this._fadeInDuration
  }

  /**
   * @param {number} duration
   */
  set fadeInDuration(duration) {
    this._fadeInDuration = duration
  }

  /**
   * @returns {number} 100-nanoseconds units
   */
  get fadeOutDuration() {
    return this._fadeOutDuration
  }

  /**
   * @param {number} duration
   */
  set fadeOutDuration(duration) {
    this._fadeOutDuration = duration
  }

  // ---
  /**
   * @returns {boolean}
   */
  get fadeInIsActive() {
    return this._fadeInIsActive
  }

  /**
   * @param {boolean} isActive
   */
  set fadeInIsActive(isActive) {
    this._fadeInIsActive = isActive
  }


  // ---
  /**
   * @returns {boolean}
   */
  get fadeOutIsActive() {
    return this._fadeOutIsActive
  }

  /**
   * @param {boolean} isActive
   */
  set fadeOutIsActive(isActive) {
    this._fadeOutIsActive = isActive
  }

  /**
   * @return {number}
   */
  get fpsNum() {
    return this._fpsNum || DEFAULT_FPS
  }

  /**
   * @param {number}
   */
  set fpsNum(value) {
    this._fpsNum = value
  }

  /**
  * @return {number}
  */
  get fpsDenum() {
    return this._fpsDenum || 1
  }

  /**
   * @param {number}
   */
  set fpsDenum(value) {
    this._fpsDenum = value
  }

  /**
   * @return {number}
   */
  get fps() {
    return this.fpsNum / this.fpsDenum
  }

}

export default ProjectVideoAsset
